import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/socialGroup.ts

var socialGroup_exports = {};

__export(socialGroup_exports, {
  join: function join() {
    return _join;
  },
  leave: function leave() {
    return _leave;
  }
});

var _join = function _join(_ref) {
  var id = _ref.id;
  return fetcher_default.post("/v4/social_groups/" + id + "/join");
};

var _leave = function _leave(_ref2) {
  var id = _ref2.id;
  return fetcher_default.post("/v4/social_groups/" + id + "/leave");
};

export { _join as join, _leave as leave, socialGroup_exports };